import * as React from 'react';

const SvgMenu = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='18'
    viewBox='0 0 22 18'
    xmlSpace='preserve'
    {...props}
  >
    <path d='M4.55084 3.6264L0.251953 3.6264L1.32667 0.402237L5.62556 0.402237L4.55084 3.6264Z' />
    <path d='M12.6114 3.6264L8.3125 3.6264L9.38722 0.402237L13.6861 0.402237L12.6114 3.6264Z' />
    <path d='M20.6719 3.6264L16.373 3.6264L17.4478 0.402237L21.7467 0.402237L20.6719 3.6264Z' />
    <path d='M4.55084 10.6121H0.251953L1.32667 7.38791L5.62556 7.38791L4.55084 10.6121Z' />
    <path d='M12.6114 10.6121H8.3125L9.38722 7.38791L13.6861 7.38791L12.6114 10.6121Z' />
    <path d='M20.6719 10.6121H16.373L17.4478 7.38791L21.7467 7.38791L20.6719 10.6121Z' />
    <path d='M4.55084 17.5978H0.251953L1.32667 14.3736H5.62556L4.55084 17.5978Z' />
    <path d='M12.6114 17.5978H8.3125L9.38722 14.3736H13.6861L12.6114 17.5978Z' />
    <path d='M20.6719 17.5978H16.373L17.4478 14.3736H21.7467L20.6719 17.5978Z' />
  </svg>
);

export default SvgMenu;
